export default {
  reloadControllerConfig: 'Przeładuj konfigurację kontrolera',
};
